import { defineFormKitConfig } from '@formkit/vue'
import { createProPlugin, inputs } from '@formkit/pro'
import { de, fr, it, en } from '@formkit/i18n'
import { close } from '@formkit/icons'
import { rootClasses } from './formkit.theme'

const proPlugin = createProPlugin('fk-2af258dc5', inputs)

const legends = ['checkbox_multi', 'radio_multi', 'repeater', 'transferlist']

/* eslint-disable  @typescript-eslint/no-explicit-any */
function addAsteriskPlugin(node: any) {
  if (
    ['button', 'submit', 'hidden', 'group', 'list', 'meta'].includes(
      node.props.type,
    )
  )
    return
  node.on('created', () => {
    const legendOrLabel = legends.includes(
      `${node.props.type}${node.props.options ? '_multi' : ''}`,
    )
      ? 'legend'
      : 'label'
    if (node.props.definition.schemaMemoKey) {
      node.props.definition.schemaMemoKey += `${node.props.options ? '_multi' : ''}_add_asterisk`
    }
    const schemaFn = node.props.definition.schema
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    node.props.definition.schema = (sectionsSchema: any = {}) => {
      sectionsSchema[legendOrLabel] = {
        children: [
          {
            $el: 'span',
            attrs: {
              innerHTML: '$label',
            },
            children: '',
          },
          {
            $el: 'span',
            if: '$state.required || $attrs.required',
            attrs: {
              class: '$classes.asterisk',
            },
            children: ['*'],
          },
        ],
      }
      return schemaFn(sectionsSchema)
    }
  })
}

export default defineFormKitConfig(() => {
  return {
    config: {
      rootClasses,
    },
    plugins: [proPlugin, addAsteriskPlugin],
    locales: { de, fr, it, en },
    locale: 'de',
    icons: {
      fileRemove: close,
    },
  }
})
